import userVerifications from "./userVerifications.component";
import userVerificationsUrls from "./userVerifications.urls";
import UserVerificationsTransforms from "./userVerifications.transforms";

const userVerificationsModule = angular
  .module("app.components.userVerifications", [])
  .component("userVerificationsPage", userVerifications)
  .service("UserVerificationsTransforms", UserVerificationsTransforms)
  .config(userVerificationsUrls);

export default userVerificationsModule;



// WEBPACK FOOTER //
// ./src/pages/userVerifications/userVerifications.module.js